export default "__VITE_ASSET__5373acfd__"